import {
  APPLICATION_STAGE,
  DEED_ORGANIZER_URI,
  DEED_CLIENT_URI,
  DEED_DONATION_BATCH_API_URI,
  DEED_LEGACY_API_URI,
  DEED_GRAPH_API_URI,
  DEED_NONPROFIT_API_URI,
  DEED_LOGGED_TIME_API_URI,
  DEED_PAYROLL_API_URI,
  DEED_TIME_OFF_API_URI,
  DEED_OPPORTUNITIES_API_URI,
  STRIPE_CLIENT_ID,
  DEED_ORGANIZER_REPORT_SERVICE_API_URL,
  SEGMENT_WRITE_KEY,
  PAYPAL_ENV,
  PAYPAL_SSO_CLIENT_ID,
  DEED_NONPROFIT_SUCCESS_TEAM_EMAIL,
  GOOGLE_MAPS_API_KEY,
  // @ts-expect-error env is defined
  // eslint-disable-next-line import/no-unresolved
} from '@env';

const config = {
  environment: APPLICATION_STAGE,
  isProduction: APPLICATION_STAGE === 'production',
  isDemo: APPLICATION_STAGE === 'demo',
  isTesting: APPLICATION_STAGE === 'testing',
  isTest: APPLICATION_STAGE === 'test',
  isLocal: APPLICATION_STAGE === 'local',
  isDevelopment: APPLICATION_STAGE === 'development',
  apiUrl: DEED_LEGACY_API_URI,
  graphApiUrl: DEED_GRAPH_API_URI,
  nonprofitApiUrl: DEED_NONPROFIT_API_URI,
  loggedTimeApiUrl: DEED_LOGGED_TIME_API_URI,
  donationBatchApiUrl: DEED_DONATION_BATCH_API_URI,
  payrollApiUrl: DEED_PAYROLL_API_URI,
  timeOffApiUrl: DEED_TIME_OFF_API_URI,
  opportunitiesUrl: DEED_OPPORTUNITIES_API_URI,
  organizerUri: DEED_ORGANIZER_URI,
  clientUrl: DEED_CLIENT_URI,
  stripeClientId: STRIPE_CLIENT_ID,
  reportApiUrl: DEED_ORGANIZER_REPORT_SERVICE_API_URL,
  segment: SEGMENT_WRITE_KEY,
  payPalEnv: PAYPAL_ENV,
  payPalClientId: PAYPAL_SSO_CLIENT_ID,
  nonprofitSuccessTeamEmail: DEED_NONPROFIT_SUCCESS_TEAM_EMAIL,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
};

export default config;
